import { useState } from "react";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { TableItemId } from "../../../../components/tables/TableWidget";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";
import QuarantineSolutionsModal from "../QuarantineSolutionsModal";
import QuarantineSolutionResolveModal from "../QuarantineSolutionResolveModal/QuarantineSolutionResolveModal";

interface QuarantineTableActionButtonProps {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  showViewButton?: boolean;
  showEditButton?: boolean;
  showDeleteButton?: boolean;
}

function QuarantineTableActionButton({
  crudData,
}: QuarantineTableActionButtonProps) {
  const [showSolutionResolveModal, setShowSolutionResolveModal] =
    useState(false);
  const [showSolutionsModal, setShowSolutionsModal] = useState(false);

  const toggleSolutionResolveModal = (showModal = false) => {
    setShowSolutionResolveModal(showModal);
  };

  const onQuarantineResolvePress = () => {
    setShowSolutionResolveModal(true);
  };

  const toggleSolutionsModal = (showModal = false) => {
    setShowSolutionsModal(showModal);
  };

  const onQuarantinePress = () => {
    setShowSolutionsModal(true);
  };

  const showResolveQuarantineButton =
    crudData?.cantitateSolutionata < Math.abs(crudData?.diferenta);

  const showSolutionsButton = crudData?.cantitateSolutionata > 0;
  const items: ActionMenuItem[] = [
    {
      id: "resolve-quarantine",
      label: "Solutioneaza neconformitatile",
      icon: "QUARANTINE",
      tooltip: showResolveQuarantineButton
        ? "Deschide solutionarea neconformitatilor ramase pentru produs."
        : "Nu mai exista cantitati nesolutionate pentru acest produs.",
      hidden: Boolean(crudData?.solutionare),
      disabled: !showResolveQuarantineButton,
      onClick: onQuarantineResolvePress,
    },
    {
      id: "view-solutions",
      label: "Vezi solutionari",
      icon: "HISTORY",
      tooltip: showSolutionsButton
        ? "Afiseaza solutionarile inregistrate pentru acest produs."
        : "Nu exista inca solutionari inregistrate pentru acest produs.",
      hidden: Boolean(crudData?.solutionare),
      disabled: !showSolutionsButton,
      onClick: onQuarantinePress,
    },
  ];

  return (
    <div className="text-right">
      <ActionMenu
        items={items}
        minItemsForMenu={2}
        title={crudData?.numeProdus}
        ariaLabel="Actiuni pentru produsul din carantina"
      />
      {!crudData?.solutionare && (
        <>
          {showSolutionResolveModal && (
            <QuarantineSolutionResolveModal
              showModal={showSolutionResolveModal}
              toggleModal={toggleSolutionResolveModal}
              crudData={crudData}
            />
          )}
          {showSolutionsButton && (
            <QuarantineSolutionsModal
              showModal={showSolutionsModal}
              toggleModal={toggleSolutionsModal}
              crudData={crudData}
            />
          )}
        </>
      )}
    </div>
  );
}

export default QuarantineTableActionButton;
